import { render } from "./SubmissionSentModal.vue?vue&type=template&id=a3f3e962&scoped=true"
import script from "./SubmissionSentModal.vue?vue&type=script&lang=js"
export * from "./SubmissionSentModal.vue?vue&type=script&lang=js"

import "./SubmissionSentModal.vue?vue&type=style&index=0&id=a3f3e962&scoped=true&lang=css"

import exportComponent from "/app/code_base/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3f3e962"]])

export default __exports__